export default "__VITE_ASSET__cb0d6e67__"